@for (img of media; track img; let i = $index) {
  <div
    class="thumbnails-carousel"
    (click)="setMedia(i)"
    (keydown)="null"
    [attr.data-index]="i"
    [ngStyle]="{'width': 'calc(' + thumbnailWidth + 'px - 2px)'}"
    [ngClass]="{'selected border-blue': i === mediaIndex && currentMediaType === img.mediaObject.object_type}"
  >
    @if (img.mediaObject.object_type.toLowerCase() === 'model3d') {
      <mat-icon class="thumbnails-carousel__fallback-icon">{{ mediaFallbackIcon(img.mediaObject.object_type, img.mediaObject.$$dmsStatus) }}</mat-icon>
    } @else if (!isNotReady(img.mediaObject.$$dmsStatus) && !isInvalidSrc(img.mediaObject.$$thumbUrl)) {
      <img
        id='thumb-{{img.mediaObject.object_type}}-{{i}}'
        [alt]="img.mediaObject.artifact_name"
        [src]='img.mediaObject.$$thumbUrl'
        (error)="onThumbnailError(img.mediaObject)"
      >
    } @else {
      <div class="thumbnails-carousel__fallback">
        <mat-icon class="thumbnails-carousel__fallback-icon">{{ mediaFallbackIcon(img.mediaObject.object_type, img.mediaObject.$$dmsStatus) }}</mat-icon>
        @if (isNotReady(img.mediaObject.$$dmsStatus)) {
          <mat-progress-bar
            class="thumbnails-carousel__not-ready-bar"
            color="accent"
            mode="indeterminate"
            aria-hidden="true"
          ></mat-progress-bar>
        }
      </div>
    }

    <div class="thumbnails-carousel__media-type">
      <i class="icon-{{img.mediaObject.object_type.toLowerCase()}}"></i>
    </div>
  </div>
}
